import React, { useRef, useEffect } from "react";
import { cropFileName } from "../../helpers/conversions";

export const InputFileGeneric = ({label, accept, onChange, fileName, id, description}) => {
    const ref = useRef();

    useEffect(() => {
        if (!fileName && ref.current) {
            ref.current.value = '';
        }
    }, [fileName]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (onChange) {
            onChange(file);
        }
    }

    const getDisplayName = () => {
        if (fileName) {
            return cropFileName(fileName);
        }
        return 'Escolher arquivo';
    }

    return (
        <div className="input-group">
            {label &&
                <label>{label}</label>
            }
            <div className="input-file-content">
                <input 
                    ref={ref} 
                    id={id}
                    type="file" 
                    onChange={handleFileChange}
                    accept={accept}
                />
                <button 
                    type="button" 
                    className={fileName ? "complete" : "choose"} 
                    onClick={() => ref.current.click()}
                >
                    {fileName ? (
                        <>
                            <img src={require(`../../assets/images/svgs/upload-small.svg`).default} alt="" />
                            {getDisplayName()}
                        </>
                    ) : (
                        <>
                            <img src={require(`../../assets/images/svgs/upload-small.svg`).default} alt="" />
                            Escolher
                        </>
                    )}
                </button>
            </div>
            {description &&
                <span className="desc">{description}</span>
            }
        </div>
    );
}

export default InputFileGeneric;

